import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function MenuCatalogDialog({ open, onClose, value, onChange, onProceed }) {
  const handleRadioChange = (event) => {
    const newValue = event.target.value;
    const newType = newValue; // Assuming type is the same as value
    onChange(newValue, newType);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: 3, border: '2px solid #2196f3', minWidth: 380, maxWidth: 420 },
      }}
    >
      <DialogContent sx={{ position: 'relative', pb: 3 }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 14,
            right: 14,
            background: '#f3f3f3',
            '&:hover': { background: '#e0e0e0' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Divider */}
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 1 }}>
          <Box sx={{ borderTop: '2px solid #222', width: 120 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          align="center"
          sx={{ fontWeight: 'bold', color: '#6c00e6', mb: 2 }}
        >
          menu or catalog?
        </Typography>

        {/* Radio Options */}
        <RadioGroup
          row
          value={value}
          onChange={handleRadioChange}
          sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}
        >
          <FormControlLabel
            value="menu"
            control={<Radio sx={{
              color: '#6c00e6',
              '&.Mui-checked': { color: '#6c00e6' },
            }} />}
            label={<Typography sx={{ fontSize: 20 }}>menu</Typography>}
          />
          <FormControlLabel
            value="catalog"
            control={<Radio sx={{
              color: '#222',
              '&.Mui-checked': { color: '#6c00e6' },
            }} />}
            label={<Typography sx={{ fontSize: 20 }}>catalog</Typography>}
          />
        </RadioGroup>

        {/* Proceed Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={onProceed}
          disabled={!value} // Disable button if no value is selected
          sx={{
            background: '#6c00e6',
            borderRadius: 2,
            py: 1.5,
            fontSize: 24,
            textTransform: 'none',
            boxShadow: 0,
            '&:hover': { background: '#4b00b5' },
            '&:disabled': { background: '#ccc' },
          }}
        >
          proceed
        </Button>
      </DialogContent>
    </Dialog>
  );
}